module.exports = __webpack_public_path__ + "img/Discord-Logo-White.1c8a54f2.svg";